import { FC } from 'react';

/**
 * Answers "how much is left?" without making the investor count cards. Deliberately reports
 * only the documents the investor is responsible for — mixing in the items AngelList supplies
 * and the ones produced by e-signature made the bar look permanently stuck.
 */
const ChecklistProgress: FC<{ completed: number; total: number }> = ({ completed, total }) => {
  const percentComplete = total === 0 ? 100 : Math.round((completed / total) * 100);

  return (
    <div className="flex items-center gap-3">
      <div className="h-2 flex-1 overflow-hidden rounded-full bg-gray-200">
        <div
          className="h-full rounded-full bg-indigo-600 transition-all"
          style={{ width: `${percentComplete}%` }}
        />
      </div>
      <p className="shrink-0 text-sm text-gray-600">
        {completed} of {total} uploaded
      </p>
    </div>
  );
};

export default ChecklistProgress;
